module.exports = __webpack_public_path__ + "static/Chart-Integration-e034888733f72c6b547f73bcc09bb9ba.png";